// file: `react/src/components/Logout.tsx`:

import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useCrypto } from './CryptoContext.tsx';
import { useUser } from './UserContext.tsx';
import { expressURL, getAuthHeaders } from '../utils/networkUtils';
import { unsubscribeFromPush } from '../utils/pushNotifications.ts';
import { clearAuthToken } from '../utils/authToken.ts';

const LOGOUT_PUSH_TIMEOUT_MS = 3000;

function Logout() {
  const navigate = useNavigate();
  const { lock } = useCrypto();
  const { setActiveUser } = useUser();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        await Promise.race([
          unsubscribeFromPush(),
          new Promise((_resolve, reject) => {
            setTimeout(() => reject(new Error('Push unsubscribe timed out')), LOGOUT_PUSH_TIMEOUT_MS);
          })
        ]);
      } catch (_) {
        /* best-effort while JWT is still present */
      }

      try {
        await fetch(`${expressURL()}/auth/logout`, {
          method: 'POST',
          ...getAuthHeaders()
        });
      } catch (_) {
        /* cookie clear is best-effort */
      }

      if (cancelled) return;
      lock();
      setActiveUser(null);
      clearAuthToken();
      navigate('/login');
    })();

    return () => {
      cancelled = true;
    };
  }, [lock, navigate, setActiveUser]);

  return null;
}

export default Logout;
